export const m = {
  // 操作提示
  selectFileTip: "請選擇文件",
  selectIncorrectTip: "請選擇正確的",
  incorrectTip: "請輸入正確的",
  emptyTip: "不能空白",
  editTip: "修改成功",
  createdTip: "創建成功",
  secondPsdDifferentTip: "密碼與確認密碼不一致",
  deleteConfirmTip: "確定刪除",
  deletedTip: "刪除成功",
  uploadedTip: "上傳成功",
  savedTip: "保存成功",
  searchTip: "搜索",
  // 按钮
  cancelBtn: "取消",
  confirmBtn: "確定",
  createBtn: "創建",
  nextBtn: "下一步",
  // 登录页面
  loginTip: "請登錄您的賬戶",
  email: "電子郵件",
  password: "密碼",
  signIn: "登錄",
  login: "登錄",
  forgetPsd: "忘記密碼",
  securityCode: "驗證碼",
  verfication: "驗證",
  send: "發送",
  loginNewPsd: "新密碼",
  confirmNewPsd: "確認新密碼",
  return: "返回",
  emailErrorTip: "請輸入正確的郵箱",
  // 首页
  sites: "站點",
  // 联系客服提示
  allFuncTip:
    "感謝您的體驗，如果您想使⽤全部功能，可以聯絡我們或填寫您的電子郵件，我們會盡快與您聯絡",
  ourContact: "我們的聯絡方式",
  yourEmail: "您的電子郵件",
  submit: "提交",
  remark: "備註",
  // 新用户导航提示
  createAssetTitleTip: "按這裡，可以快速建立模擬資產。",
  createAssetTip:
        "(模擬資產不會產⽣實際的收集數據，如果你想體驗所有功能，請聯絡我們：info@xrenewable.com)",
  paramEditTitleTip:
        "要為你建立的模擬資產配置税率，請按這裡並選擇“客製化參數⼯具”",
  paramEditTip:
        "(客製化的税率數據僅供參考，如果你想體驗所有功能，請聯絡我們：info@xrenewable.com)",
  scheduleEditTitleTip: "要為資產配置調度計劃和⼯單，請按這裡。",
  scheduleEditTip:
        "(模擬的資產暫時無法提供這項功能，如果你想體驗所有功能，請聯絡我們：info@xrenewable.com)",
  assetOperationTitleTip:
        "要了解資產的運維訊息，包括警報、⼯單和其他數據的統計資料，請按這裡。",
  assetOperationTip:
        "(模擬的資產暫時無法提供這項功能，如果你想體驗所有功能，請聯絡我們：info@xrenewable.com)",
  prev: "上⼀步",
  next: "下⼀步",
  alreadyKnow: "我已瞭解",
  my: "賬單",
  assets: "站點",
  // 用户功能
  funcUserInfo: "個人訊息",
  funcChangePsd: "更改密碼",
  funcLoginOut: "退出登錄",
  funcManageChannel: "渠道商管理",
  funcManageUser: "用戶管理",
  setUserInfo: "個人訊息設置",
  userName: "用戶名",
  userPhone: "聯繫方式",
  userRemark: "備註",
  setSaveBtn: "保存",
  changePsdTitle: "更改密碼",
  originPsd: "原密碼",
  newPsd: "新密碼",
  confirmPsd: "確認新密碼",
  // 站点数据
  dashboard: "數據",
  liveMonitor: "實时監視器",
  Configuration: "配寘",
  // 站点编辑
  siteScene: "場景類型",
  siteAdd: "新增站點",
  siteEdit: "編輯站點",
  assetAdd: "新增資產",
  assetEdit: "編輯資產",
  assetType: "資產類型",
  assetPVEdit: "編輯光伏資產",
  assetESEdit: "編輯儲能資產",
  assetLoadEdit: "編輯負荷",
  assetPVAdd: "光伏",
  assetESAdd: "儲能",
  assetLoadAdd: "負荷",
  assetPV: "光伏資產",
  assetES: "儲能",
  assetLoad: "負荷",
  energyStorage: "儲能",
  photovoltaic: "光伏",
  load: "負荷",
  siteName: "站點名稱",
  siteType: "站點類型",
  owner: "業主",
  longitude: "經度",
  latitude: "緯度",
  longitudeAndLatitude: "經緯度",
  timeZone: "時區",
  powerSupplier: "電力供應商",
  maxImportCapacity: "最大輸入容量",
  maxExportCapacity: "最大輸出容量",
  SEGUnitRate: "上網電價",
  tariffPeriod: "用電價格",
  siteAddress: "站點所在地址",
  importMPAN: "用電MPAN",
  exportMPAN: "賣電MPAN",
  importMPRN: "用電MPRN",
  exportMPRN: "賣電MPRN",
  applicationType: "應用類型",
  cannotRepeatTip: "不能重複",
  // 资产页面
  schedulePredictionTime: "預測時間",
  setAssetParam: "調整資產參數",
  setAssetTariff: "調整電價",
  setAssetSchedule: "調整維修",
  all: "全部",
  assetName: "名稱",
  installedCapacity: "裝機容量",
  assetStatus: "狀態",
  ratedPower: "額定功率",
  distance: "距離",
  expectedIncome: "預期收入",
  dailyCycle: "預期日循環",
  emptyDataTip: "暫無數據",
  today: "日前預測",
  tomorrow: "日內數據",
  data: "數據",
  view: "顯示",
  power: "功率",
  unitRatedPower: "單位額定功率",
  pvPanelNum: "光伏板數量",
  totalRatedPower: "總額定功率",
  firstYearAttenuation: "首年衰减",
  linearAttenuationRate: "線性衰减率",
  loadAssetType: "負荷類型",
  pvPowerGeneration: "光伏發電量",
  Solar: "太陽能",
  Battery: "儲能",
  Grid: "電網",
  selfConsumption: "自用",
  bess: "儲能",
  grid: "電網",
  estimatedLoad: "用電量",
  energyStorageChargeAndDischarge: "儲能充放電量",
  photovoltaicCharging: "光伏充入",
  gridCharging: "電網充入",
  putItIntoElectricity: "放入電網",
  feederNetwork: "放入負荷",
  day: "日",
  night: "夜",
  todayText: "今天",
  backToday: "返回今天",
  limitAssetNumTip: "請至少添加一個資產",
  chargingPower: "充電功率",
  // 充电桩信息
  chargingPile: "充電樁",
  chargingPileConnectors: "連接器數量",
  chargingPileTariffPeriod: "充電電價",
  chargingPileNo: "編號",
  chargingPilePower: "功率",
  // powermodule
  ACDC: "AC/DC",
  chargingDCDC: "Charging DC/DC",
  PVDCDC: "PV DC/DC",
  batteryDCDC: "Battery DC/DC",
  // 流向图
  importAndExportMeter: "單儀錶輸入輸出",
  importOnly: "僅輸入",
  importAndExport: "輸入輸出",
  exportOnly: "僅輸出",
  solorToGridDirectly: "太陽能直接並網",
  totalImportFromGrid: "電網總輸入",
  totalExportFromGrid: "電網總輸出",
  loadMetFromSolar: "太陽能負載",
  bessChargeFromSolar: "太陽能充電",
  loadMetFromGrid: "電網負載",
  bessChargeFromGrid: "電網充電",
  bessDischargeToGrid: "電網放電",
  bessDischargeToLoad: "負荷放電",
  meter1: "儀錶1",
  meter2: "儀錶2",
  meter1Text: "儀錶1：輸入輸出",
  // 算法数据
  charge: "充電",
  discharge: "放電",
  ffr: "輔助市場服務",
  outage: "維修",
  standby: "待機",
  soc: "電量",
  batteryCapacity: "電池容量",
  tariff: "電價",
  startSOC: "初始電量",
  endSOC: "結束電量",
  normalInfo: "基本訊息",
  schedule: "調度計畫表",
  schedulingCalendar: "調度日曆",
  operationInfo: "運維訊息",
  map: "地圖",
  alarmData: "報警統計",
  // 资产参数
  serialNumber: "硬體設備序列號",
  equipmentManufacturer: "設備製造商",
  omOperator: "O&M營運方",
  assetOwner: "資產業主",
  assetNo: "資產編號",
  country: "選擇國家",
  area: "選擇地區",
  address: "資產所在地址",
  assetLongitude: "資產經度",
  assetLatitude: "資產緯度",
  assetTimezone: "資產時區",
  voltage: "電壓",
  dno: "配電網公司",
  type: "類型",
  projectApplicationCategory: "項目應用類別",
  cycleEfficiency: "充放電效率",
  warrantyPeriod: "保證年限",
  attenuationCurve: "SOH",
  lifeCycleCycles: "生命週期循環次數",
  temperature: "工作溫度",
  maxTemperature: "最大工作溫度",
  minTemperature: "最小工作溫度",
  coolingTime: "充放电冷却时间",
  minDayCycles: "最小日循環次數",
  maxDayCycles: "最大日循環次數",
  minYearCycles: "最小年循環次數",
  maxYearCycles: "最大年循環次數",
  operationTime: "營運時間",
  operationStatus: "營運狀態",
  notBuilt: "未建成",
  built: "已建成",
  inOperation: "已正式商業運營",
  unitYear: "年",
  pileName: "充電樁名稱",
  pileNo: "充電樁編號",
  pileManufacturer: "充電樁製造商",
  pileSerialNo: "充電樁序號",
  gunNo: "充電槍編號",
  gunSerialNumber: "充電槍序號",
  gunPower: "充電槍功率",
  // 辅助市场服务实时数据页
  frequency: "頻率",
  actualPower: "實際功率",
  targetPower: "目標功率",
  currentTime: "當前時間",
  targetTotalPower: "目標累計電量",
  actualTotalPower: "累計電量",
  powerScheduleEfficiency: "功率調度效能",
  batteryScheduleEfficiency: "電量調度效能",
  outaging: "正在維修中...",
  pvEnergy: "光伏發電量",
  batteryChargeEnergy: "儲能充電量",
  batteryDischargeEnergy: "儲能放電量",
  loadEnergy: "負荷用電量",
  pvPower: "光伏功率",
  batteryPower: "電池功率",
  loadPower: "負荷功率",
  globalRadiation: "太陽輻射",
  cloud: "雲層",
  weatherTemperature: "溫度",
  // 账单页
  no: "編號",
  estimatedAccount: "估算帳單",
  detail: "明細",
  MonthlyAccountdetail: "每月明細帳單",
  contractEstimate: "合約估算",
  deviation: "偏差",
  actualIncome: "實際收入",
  total: "總計",
  date: "日期",
  amountOfMoney: "金額",
  dailyAccountdetail: "每日明細帳單",
  estimatedIncome: "估算收入",
  uploadMonthlyAccount: "上傳每月帳單",
  downloadMonthlyAccount: "下載每月帳單",
  selectFile: "選擇文件",
  estimatedSOC: "估算SOC",
  actualSOC: "實際SOC",
  tariffSelect: "電價選擇",
  profileType: "電錶類型",
  lineLossFactor: "線損係數",
  distributor: "經銷商",
  workorderCreate: "創建工單",
  scheduleCreate: "創建調度計劃",
  tool: "工具",
  ffrMode: "選擇輔助市場服務模式",
  availabilityPrice: "可用價格",
  utilisationPrice: "使用價格",
  selectWorkDay: "選擇服務日",
  selectTime: "選擇時間",
  EstimatedRevenue: "估算收入",
  saveSetting: "保存設置",
  isDeleteSchedule: "是否要刪除該調度計劃",
  gained: "已收益",
  urealisedBenefits: "未實現收益",
  investment: "投資",
  tenYearsExpectGained: "生命週期預期收益",
  returnOfInvestment: "投資回報",
  expectGained: "預期收入",
  month: "月",
  year: "年",
  totalSingle: "總",
  fromInstall: "自安裝起",
  electricitySaving: "自發自用收益",
  PowerGenerationIncome: "發電上網收益",
  revenue: "總收益",
  monthlySaving: "月節約",
  monthlyElectricitySaving: "月節約電費",
  monthlyPowerGenerationIncome: "收益",
  annualSaving: "年節約",
  annualElectricitySaving: "年節約電費",
  annualPowerGenerationIncome: "收益",
  totalSaving: "總節約",
  totalElectricitySaving: "總節約電費",
  totalPowerGenerationIncome: "總發電上網收益",
  recovered: "已收回",
  totalInvestment: "總投資額",
  saved: "已節約",
  estimatedSavings: "預計節約",
  // 资产设置单页面
  selectTariff: "選擇電價",
  selectDate: "選擇日期",
  mode: "模式",
  timeRange: "時間段",
  keepSOC: "保持SOC",
  kWh: "kWh",
  startTime: "開始時間",
  endTime: "結束時間",
  auto: "自動",
  resetBtn: "恢復默認",
  viewBtn: "預覽",
  timeRepeatTip: "重複選擇時間",
  dailyCycleFaultTip: "最大日循環次數不能小於最小日循環次數",
  cycleEfficiencyFaultTip: "請輸入正確的充放電效率",
  // 调度计划页面
  viewSchedule: "查看調度計畫",
  createSchedule: "查看調度計畫",
  scheduleList: "計畫列表",
  time: "時間",
  // 用户管理
  userManage: "用戶管理",
  user: "用戶",
  delete: "删除",
  userList: "用戶列表",
  name: "姓名",
  phone: "電話",
  channel: "渠道",
  role: "角色",
  operate: "操作",
  edit: "編輯",
  userInfo: "用戶資訊",
  confirmPassword: "確認密碼",
  limitSelectTip: "請至少選擇一個",
  // 渠道商管理
  channelManage: "渠道商管理",
  channelProvider: "渠道商",
  channelList: "渠道商列表",
  channelName: "渠道商名稱",
  areaName: "區域",
  contactName: "連絡人",
  relateSite: "關聯站點",
  sitePool: "站點池",
  relateSuccessTip: "關聯成功",
  channelUser: "渠道商普通用戶",
  channelAdmin: "渠道商管理員",
  // 账单管理
  billManage: "帳單管理",
  billList: "帳單清單",
  bill: "帳單",
  statementDate: "報表日期",
  billType: "帳單類型",
  billName: "帳單名稱",
  uploadDate: "上傳日期",
  uploadBill: "上傳帳單",
};
